export default function dollarAmount(amount, withDecimal = true) {
  let value = "$";
  if (amount != null) {
    value += withDecimal
      ? parseFloat(amount)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : parseFloat(amount)
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    value = "";
  }

  return value;
}
